const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
export { BACKEND_URL, API };

export const STATUS_COLORS = {
  active: 'bg-emerald-600 text-white',
  en_attente_paiement: 'bg-amber-600 text-white',
  en_cours: 'bg-blue-600 text-white',
  archivee: 'bg-gray-600 text-white',
  autre: 'bg-gray-500 text-white',
};
export const STATUS_GROUP_LABELS = {
  active: 'Active', en_attente_paiement: 'Att. paiement', en_cours: 'En cours', archivee: 'Archivee', autre: 'Autre',
};
export function formatDate(dateStr) {
  if (!dateStr) return '-';
  try { return new Date(dateStr).toLocaleDateString('fr-FR'); } catch { return dateStr; }
}
export function formatMoney(val) {
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(val || 0);
}
